import axios from 'axios';
import { FETCH_BASE_TOKEN, FETCH_LOGIN_TOKEN, REFRESH_LOGIN_TOKEN, LOGOUT } from "../types";
import {BASE_TOKEN_OPTIONS, REFRESH_TOKEN_OPTIONS, BASE_TOKEN_BODY, setLoginTokenBody, setRefreshTokenBody} from '../config';
import * as Storage from '../../common/services/storage.service';
import * as actionsUser  from '../user';
import moment from 'moment';

const authTokenUrl = 'https://nuins.io/oauth2-server/oauth/token';

//const authTokenUrl = 'http://localhost:8080/web-admin/oauth/token'  //to test

export const getbaseAccessToken = () => async (dispatch, getState) => {

  let res;
  try{
    res = await axios.post(authTokenUrl, BASE_TOKEN_BODY, BASE_TOKEN_OPTIONS);
  } catch (error) {
    console.log(error);
  }

  if (res?.data) {
    Storage.setItem('baseToken', res.data.access_token)
    res.data.expires_at = moment().add(res.data.expires_in, 's').format();
  }

  const payload = res?.data;
  
  return dispatch({type: FETCH_BASE_TOKEN, payload:payload});
}

export const getLoginToken = (username, passsword) => async (dispatch, getState) => {

  const body = setLoginTokenBody(username, passsword);

  let res;
  try{
    res = await axios.post(authTokenUrl, body, BASE_TOKEN_OPTIONS);
  } catch (error) {
    console.log(error);
  }

  if (res?.data) {
    const expiresAt = moment().add(res.data.expires_in, 's').format();
  // Storage.setItem('loginToken', res.data.access_token);
  // Storage.setItem('refreshToken', res.data.refresh_token);
  // Storage.setItem('expiresAt', expiresAt);
    res.data.expires_at = expiresAt;
  }

 // console.log(res)

  const payload = res?.data;

  return dispatch({type: FETCH_LOGIN_TOKEN, payload:payload});
}

export const refreshLoginToken = (refreshToken) => async (dispatch, getState) => {

  const {auth} = getState();

  if(!auth?.loginToken && !refreshToken) {
   return;
  }

  refreshToken = refreshToken || auth?.loginToken?.refresh_token;

  const body = setRefreshTokenBody(refreshToken);

  let res;
  try{
    res = await axios.post(authTokenUrl, body, REFRESH_TOKEN_OPTIONS);
  } catch (error) {
    console.log(error);
  }

  if (res?.data) {
    const expiresAt = moment().add(res.data.expires_in, 's').format();
  // Storage.setItem('loginToken', res.data.access_token);
  // Storage.setItem('refreshToken', res.data.refresh_token);
  // Storage.setItem('expiresAt', expiresAt);
    res.data.expires_at = expiresAt;
  }

  //console.log(res)

  const payload = res?.data;

  return dispatch({type: REFRESH_LOGIN_TOKEN, payload:payload});
}

export const validateAndRefreshTokens = () => async (dispatch, getState) => {
  const {auth} = getState();

  //console.log(auth)

  if(auth?.loginToken) {
    if(!Storage.isValidLoginToken(auth?.loginToken)) {

      console.log('expired')
      await dispatch(refreshLoginToken());

    } else {return }

  } else if(!auth?.baseToken || !Storage.isValidToken(auth?.baseToken?.expires_at)) {

    await dispatch(getbaseAccessToken());
  }
}

export const logout = () => (dispatch, getState) => {

  dispatch(actionsUser.clearUserDetails());
  
  return dispatch({type: LOGOUT, payload: null});
}
